import Vue from 'vue';
import Router from 'vue-router';
import Layout from '../layout/Layout.vue';
import Login from '@/views/login'; //首页
import Stumobile from '@/views/stuclassmobile'; //首页

Vue.use(Router);
export default new Router({
  routes: [
    //APP首页
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    //APP首页
    {
      path: '/stumobile',
      name: 'Stumobile',
      component: Stumobile,
    },
    {
      path: '/',
      component: Layout,
      redirect: '/updateclasshour',
      //meta可以不写
      children: [
        {
          path: '/updateclasshour',
          name: '课时管理',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/updateclasshour.vue'),
        },
        {
          path: '/classhour',
          name: 'Lesson Schedule',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/classhour.vue'),
        },
        {
          path: '/class',
          name: '班级管理',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/class.vue'),
        },
        {
          path: '/course',
          name: '课程管理',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/course.vue'),
        },
        {
          path: '/level',
          name: '级别管理',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/level.vue'),
        },
        {
          path: '/user',
          name: '用户管理',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/user.vue'),
        },
        {
          path: '/userdetail',
          name: '用户详情',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/userdetail.vue'),
        },
        {
          path: '/count_classhour',
          name: '课时统计',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/count_classhour.vue'),
        },
        {
          path: '/count_user',
          name: '用户统计',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/count_user.vue'),
        },
        {
          path: '/count_class',
          name: '班级统计',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/count_class.vue'),
        },
        {
          path: '/count_money',
          name: '收支统计',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/count_money.vue'),
        },
        {
          path: '/pinClass',
          name: '拼班管理',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/pinclass.vue'),
        },
        {
          path: '/syllabus',
          name: '课表',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/syllabus.vue'),
        },
        {
          path: '/pricezero',
          name: '查零',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/pricezero.vue'),
        },
        {
          path: '/teamonthprice',
          name: '月价格',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/teamonthprice.vue'),
        },
        {
          path: '/exportTeaPrice',
          name: '导出薪资',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/exportTeaPrice.vue'),
        },
        {
          path: '/exportTeaFree',
          name: '导出空闲',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/exportTeaFree.vue'),
        },
        {
          path: '/exportLeaveLog',
          name: '请假日志',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/exportLeaveLog.vue'),
        },
        {
          path: '/managerClassHour',
          name: '课时统计',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/managerClassHour.vue'),
        },
        {
          path: '/oneDayClassHour',
          name: '单日统计',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/oneDayClassHour.vue'),
        },
        {
          path: '/exportCLevel',
          name: '级别管理',
          meta: {},
          component: () => import(/* webpackChunkName: "home" */ '../views/exportCLevel.vue'),
        },
      ],
    },
  ],
});
